import type { Route } from 'nextjs-routes';

export const PROXY_PATH = 'rental-manager/proxy';

export const ROUTES = {
  PROPERTIES: '/properties',
  LISTING: '/properties/[listingAlias]/listing',
  LISTING_SOURCES: '/properties/[listingAlias]/sources',
  FEATURE_FLAGS: '/featureFlags',
  SECURITY_INQUIRY: '/security-inquiry',
  SUBMIT_REQUEST: '/submit-request',
  LISTING_CLAIMING: '/listing-claiming',
  DASHBOARD_OVERVIEW: '/properties/[listingAlias]/dashboard/overview',
  LEAD: '/lead/[leadId]',
  INQUIRY_CONTACT: '/inquiry-contact',
  TOUR_AVAILABILITY: '/properties/[listingAlias]/tours/tour-availability',
  TOUR_CALENDAR: '/properties/[listingAlias]/tours/tour-calendar',
  SELECT_PROPERTY: '/select-property',
} as const;

export const EXTERNAL_ROUTES = {
  SIGN_IN: '/rental-manager/login/',
  PAYMENTS_DASHBOARD: '/rental-manager/payments/properties',
  OLYMPUS_REDIRECT: '/rental-manager/ad-management/ad-management-non-advertiser-olympus',
  ZRM_HOME_PAGE: '/rental-manager',
} as const;

export const EXTERNAL_URLS = {
  CORP_TERMS: 'https://www.zillow.com/corp/Terms.htm',
  RENTAL_USER_TERMS: 'https://www.zillow.com/renter-hub/terms/Rental-User-Terms',
  PLEDGE: 'https://www.zillow.com/corp/respectful-renting-pledge/',
} as const;

export function getListingRoute({ listingAlias }: { listingAlias: string }): {
  pathname: Route['pathname'];
  query: Route['query'];
} {
  return {
    // @ts-expect-error - ROUTES.LISTING is not yet part of next.js paths manifest
    pathname: ROUTES.LISTING,
    query: { listingAlias },
  };
}

export function getListingSourcesRoute({ listingAlias }: { listingAlias: string }): {
  pathname: Route['pathname'];
  query: Route['query'];
} {
  return {
    pathname: ROUTES.LISTING_SOURCES,
    query: { listingAlias },
  };
}

export function getDashboardOverviewRoute({ listingAlias }: { listingAlias: string }): {
  pathname: Route['pathname'];
  query: Route['query'];
} {
  return {
    // @ts-expect-error - ROUTES.DASHBOARD_OVERVIEW is not yet part of next.js paths manifest
    pathname: ROUTES.DASHBOARD_OVERVIEW,
    query: { listingAlias },
  };
}

export function getTourAvailabilityRoute({ listingAlias }: { listingAlias: string }): {
  pathname: Route['pathname'];
  query: Route['query'];
} {
  return {
    pathname: ROUTES.TOUR_AVAILABILITY,
    query: { listingAlias },
  };
}

export function getTourCalendarRoute({ listingAlias }: { listingAlias: string }): {
  pathname: Route['pathname'];
  query: Route['query'];
} {
  return {
    pathname: ROUTES.TOUR_CALENDAR,
    query: { listingAlias },
  };
}
